import React, { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { 
  ArrowLeft, BookOpen, User, Star, Code, Palette, TrendingUp, Users, Calculator, Camera, Heart, Globe,
  Monitor, Smartphone, Database, Cloud, Cpu, Settings, Briefcase, GraduationCap,
  Music, Video, Gamepad2, Wrench, Lightbulb, Target, BarChart3, PieChart, LineChart, Activity, Zap, Shield, Lock, Key
} from 'lucide-react'
import { CourseCard } from '../components/CourseCard'
import { cursosAPI } from '../services/api'

// Mapeamento de ícones (mesmo da sidebar)
const iconMap = {
  BookOpen, Code, Palette, TrendingUp, Users, Calculator, Camera, Heart, Globe,
  Monitor, Smartphone, Database, Cloud, Cpu, Settings, Briefcase, GraduationCap,
  Music, Video, Gamepad2, Wrench, Lightbulb, Star, Target,
  BarChart3, PieChart, LineChart, Activity, Zap, Shield, Lock, Key
}

const CursosPorCategoria = () => {
  const { categoriaId } = useParams()
  const navigate = useNavigate()
  const [categoria, setCategoria] = useState(null)
  const [cursos, setCursos] = useState([])
  const [loading, setLoading] = useState(true)
  const [loadingMatricula, setLoadingMatricula] = useState({})

  useEffect(() => {
    if (categoriaId) {
      carregarCursosCategoria()
    }
  }, [categoriaId]) // eslint-disable-line react-hooks/exhaustive-deps

  const carregarCursosCategoria = async () => {
    try {
      setLoading(true)
      const response = await fetch(`http://localhost:5000/api/categorias/${categoriaId}/cursos`)
      const data = await response.json()
      
      if (response.ok) {
        setCategoria(data.categoria)
        setCursos(data.cursos || [])
      } else {
        throw new Error(data.erro || 'Erro ao carregar cursos')
      }
    } catch (error) {
      console.error('Erro ao carregar cursos da categoria:', error)
      alert('Erro ao carregar cursos da categoria: ' + error.message)
    } finally {
      setLoading(false)
    }
  }

  const handleMatricula = async (cursoId, isMatriculado) => {
    try {
      setLoadingMatricula(prev => ({ ...prev, [cursoId]: true }))
      
      if (isMatriculado) {
        await cursosAPI.desmatricular(cursoId)
      } else {
        await cursosAPI.matricular(cursoId)
      }
      
      // Recarregar cursos para atualizar estado
      await carregarCursosCategoria()
    } catch (err) {
      console.error('Erro na matrícula:', err)
      alert(err.response?.data?.erro || 'Erro ao realizar operação')
    } finally {
      setLoadingMatricula(prev => ({ ...prev, [cursoId]: false }))
    }
  }

  const handleVerDetalhes = (cursoId) => {
    navigate(`/curso/${cursoId}`)
  }

  const handleGerarCertificado = async (cursoId) => {
    try {
      const token = localStorage.getItem('token')
      const response = await fetch('http://localhost:5000/api/certificados/gerar', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ curso_id: cursoId })
      })

      const data = await response.json()

      if (response.ok) {
        alert(`Certificado gerado com sucesso! Credencial: ${data.credential_id}`)
        
        if (data.pdf_url) {
          window.open(`http://localhost:5000${data.pdf_url}`, '_blank')
        }

        await carregarCursosCategoria()
      } else {
        throw new Error(data.erro || 'Erro ao gerar certificado')
      }
    } catch (error) {
      console.error('Erro ao gerar certificado:', error)
      alert(error.message || 'Erro ao gerar certificado')
    }
  }

  const handleVerCertificado = (certificado) => {
    if (certificado?.pdf_path) {
      window.open(`http://localhost:5000/uploads/${certificado.pdf_path}`, '_blank')
    } else if (certificado?.credential_id) {
      window.open(`/certificados/${certificado.credential_id}`, '_blank')
    }
  }

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-96 space-y-8">
        <div className="relative">
          <div className="w-20 h-20 border-4 border-slate-700 border-t-red-600 rounded-full animate-spin"></div>
          <div className="absolute inset-0 w-20 h-20 border-4 border-transparent border-l-red-500 rounded-full animate-spin animation-delay-150"></div>
        </div>
        
        <div className="text-center space-y-3">
          <h3 className="text-2xl font-bold text-white">Carregando cursos...</h3>
          <p className="text-slate-400 text-lg">Preparando o conteúdo da categoria</p>
        </div>
      </div>
    )
  }

  if (!categoria) {
    return (
      <div className="flex flex-col items-center justify-center h-96 space-y-6">
        <div className="w-24 h-24 bg-slate-800/50 rounded-lg flex items-center justify-center">
          <BookOpen className="w-12 h-12 text-slate-400" />
        </div>
        <div className="text-center space-y-3">
          <h3 className="text-2xl font-bold text-white">Categoria não encontrada</h3>
          <p className="text-slate-400">A categoria solicitada não existe ou foi removida</p>
          <button
            onClick={() => navigate('/')}
            className="px-6 py-3 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors"
          >
            Voltar ao Início
          </button>
        </div>
      </div>
    )
  }

  // Obter ícone da categoria
  const IconComponent = iconMap[categoria.icone] || BookOpen

  return (
    <div className="space-y-8">
      <div className="max-w-6xl mx-auto">
        {/* Breadcrumb e botão voltar */}
        <div className="flex items-center gap-4 mb-8">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 px-4 py-2 bg-slate-800/50 hover:bg-slate-700/50 border border-slate-700/50 rounded-lg text-slate-300 hover:text-white transition-all duration-200"
          >
            <ArrowLeft className="w-4 h-4" />
            Voltar
          </button>
          <div className="text-slate-400 text-sm">
            Início / Categorias / {categoria.nome}
          </div>
        </div>

        {/* Header da categoria */}
        <div className="bg-gradient-to-r from-slate-800/50 to-slate-700/30 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-8 mb-8">
          <div className="flex items-center gap-6">
            <div className="p-4 bg-gradient-to-r from-red-600 to-orange-500 rounded-2xl">
              <IconComponent className="w-8 h-8 text-white" />
            </div>
            <div className="flex-1">
              <h1 className="text-4xl font-bold text-white mb-2">{categoria.nome}</h1>
              {categoria.descricao && (
                <p className="text-slate-300 text-lg leading-relaxed">{categoria.descricao}</p>
              )}
              <div className="flex items-center gap-6 mt-4 text-slate-400">
                <div className="flex items-center gap-2">
                  <BookOpen className="w-4 h-4" />
                  <span>{cursos.length} curso{cursos.length !== 1 ? 's' : ''}</span>
                </div>
                <div className="flex items-center gap-2">
                  <User className="w-4 h-4" />
                  <span>{cursos.reduce((total, curso) => total + (curso.total_alunos || 0), 0)} aluno{cursos.reduce((total, curso) => total + (curso.total_alunos || 0), 0) !== 1 ? 's' : ''}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Lista de cursos */}
        {cursos.length === 0 ? (
          <div className="bg-slate-800/30 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-12 text-center">
            <div className="w-24 h-24 bg-slate-700/50 rounded-lg flex items-center justify-center mx-auto mb-6">
              <BookOpen className="w-12 h-12 text-slate-400" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-3">Nenhum curso disponível</h3>
            <p className="text-slate-400 text-lg">
              Esta categoria ainda não possui cursos cadastrados.
            </p>
          </div>
        ) : (
          <div className="space-y-8">
            <h2 className="text-2xl font-bold text-white flex items-center gap-3">
              <Star className="w-6 h-6 text-yellow-400" />
              Cursos Disponíveis
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
              {cursos.map((curso, index) => (
                <CourseCard
                  key={curso.id}
                  course={curso}
                  delay={index * 0.1}
                  onMatricula={handleMatricula}
                  onVerDetalhes={handleVerDetalhes}
                  loadingMatricula={loadingMatricula[curso.id]}
                  onGerarCertificado={handleGerarCertificado}
                  onVerCertificado={handleVerCertificado}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default CursosPorCategoria 